<template lang="pug">
	.network-show--new-episode.flex-col.space-medium
		Popup(v-if="popupVisible", :popupVisible.sync="popupVisible", :width="780", :height="720", :title="$tCaption('New episode')", :closeOnOutsideClick="false")
			.content.network-show--new-episode.flex-col.space-medium(:class="{ 'disabled-controls': isLoading }")
				.flex-row.space.justify.align-center
					.left
						.flex-col(v-if="clocks.length")
							.font-small.upper.grey {{$tCaption('Next date')}}
							.font-lg {{$moment(showDateInfo.NextDate).format('ll')}}
					.flex-col
						.font-small.upper.grey {{$tCaption('Search from date')}}
						DxDateBox(:value.sync="searchFromDate", :width="120")
				template(v-if="showDateInfo && showDateInfo.Message")
					.font-big {{showDateInfo.Message}}
				.flex-col.space-medium(v-else-if="showDateInfo")
					.flex-row.wrap
						.adt-tab.flex-row.align-center.space.font-lg(v-for="(clock, idx) in clocks", @click="activeClockIdx = idx", :class="{ active: idx === activeClockIdx }")
							.flex-row.align-center(@click.stop="")
								DxCheckBox(:value="!!clock.__generate", @value-changed="v => $set(clock, '__generate', v.value)")
							span {{$Data.secondsToDisplayValue(clock.Hour * 60 * 60, { hFormat: 'HH:mm', mFormat: 'HH:mm' }) || clock.Name}}
					.episode.flex-col.space-large(v-for="clock in [activeClock]", :class="{ 'disabled-controls': !clock.__generate }")
						.flex-col.space-large
							.insertions.flex-col.space-medium
								.font-lg(v-if="clock.Name") {{clock.Name}}
								.flex-col.space-medium
									.flex-row.space
										.flex-col.space.field.flex-1
											.font-small.upper.grey {{$tCaption('Episode name')}}
											DxTextBox(:value="clock.__episodeName", @value-changed="e => $set(clock, '__episodeName', e.value)", valueChangeEvent="input", :placeholder="clock.Name")
										.flex-col.space.field.flex-1
											.font-small.upper.grey {{$tCaption('Episode subname')}}
											DxTextBox(:value="clock.__episodeSubname", @value-changed="e => $set(clock, '__episodeSubname', e.value)", valueChangeEvent="input")
									.flex-col.space.field
										.font-small.upper.grey {{$tCaption('Episode description')}}
										DxTextBox(:value="clock.__episodeDescription", @value-changed="e => $set(clock, '__episodeDescription', e.value)", valueChangeEvent="input", :placeholder="clock.Description")
							.flex-col.space(v-if="clockInsertions[clock.Oid] && clockInsertions[clock.Oid].length")
								.font-lg.upper.grey {{$tCaption('Episode audio data')}}
								.flex-col.space-medium
									.file.flex-row.justify.space.align-center(v-for="ins in clockInsertions[clock.Oid]")
										.flex-col
											.flex-row.space
												.grey {{$Data.secondsToDisplayValue(ins.StartTime / 1000)}}
												.grey ({{$tCaption('duration')}}: {{$Data.secondsToDisplayValue(ins.Duration / 1000)}})									
											.name {{ins.Name}}
										Loader(v-if="ins.__loading", :text="`${ins.__uploadPercent || 1}%`")
										.flex-row.align-center.space.clickable.hoverable(v-else-if="ins.__file", @click="$set(ins, '__file', null)")
											fas(icon="times")
											span {{ins.__file.name}}
										FileUploader(v-else, :text="$tCaption('Select file')", @upload="v => $set(ins, '__file', v[0])", :multiple="false", :accept="['.wav', '.mp3', '.ogg']",
											:uploadText="$tCaption('Confirm', '@actions')")
				Loader(v-if="isLoading || isBusy", text="", :fullscreen="true")
			template(slot="actions-right")
				DxButton(:text="$tCaption('Cancel', '@actions')", @click="popupVisible = false", :disabled="!!isBusy")
				DxButton(:text="$tCaption('Create episode')", @click="generateEpisode", type="success", :disabled="!!isBusy || !validated")
</template>

<script>
	import _ from 'lodash';
	import Popup from 'app-core/Popup.vue';
	import EditableLabelField from 'app-core/EditableLabelField.vue';
	import Loader from 'app-core/Loader.vue';
	import { getTypeFromInsertion } from 'view/creative/detail-insertion';
	import FileUploader from 'app-core/FileUploader.vue';
	import DxCheckBox from 'devextreme-vue/check-box';
	import DxButton from 'devextreme-vue/button';
	import DxTextBox from 'devextreme-vue/text-box';
	import DxDateBox from 'devextreme-vue/date-box';

	export default {
		translationCategory: 'networkShow.NewEpisode',
		name: 'network-show--new-episode',
		props: ['networkShowId'],
		components: {
			EditableLabelField, Popup, Loader, FileUploader, DxCheckBox, DxButton, DxTextBox, DxDateBox
		},
		data() {
			return {
				popupVisible: false,
				showDateInfo: null,
				isLoading: false,
				clockInsertions: {},
				isBusy: false,
				activeClockIdx: 0,
				context: new AudioContext(),
				searchFromDate: new Date()
			};
		},
		computed: {
			activeClock() {
				return this.clocks[this.activeClockIdx];
			},
			allInsertions() {
				return Object.keys(this.clockInsertions).reduce((arr, clockId) => [...arr, ...this.clockInsertions[clockId]] , []);
			},
			clocks() {
				return _.orderBy(this.showDateInfo?.Clocks || [], ['Hour']);
			},
			validated() {
				return !this.isLoading && this.clocks.some(f => f.__generate);
			}
		},
		watch: {
			searchFromDate() {
				this.loadNewShowDate();
			}
		},
		mounted() {
			if (__DEBUG__)
				window.networkShowNewEpisode = this;
		},
		methods: {
			show() {
				this.loadNewShowDate();
				this.popupVisible = false;
				this.showDateInfo = null;
				this.activeClockIdx = 0;
				this.clockInsertions = {};
				this.searchFromDate = new Date();
				this.$nextTick(() => this.popupVisible = true);
			},
			loadNewShowDate() {
				this.isLoading++;
				this.$Data.getNetworkShowNewShowDate(this.networkShowId, this.searchFromDate)
					.then(async r => {
						this.showDateInfo = r;
						if (r.Clocks) {
							const clocks = (await this.$Data.getNetworkShowClocks(0, 999, void 0, this.networkShowId))?.Results || [];
							const nextClocks = clocks.filter(f => (this.showDateInfo.Clocks || []).some(d => d.Oid === f.Oid));
							r.Clocks = nextClocks || [];
							this.showDateInfo.Clocks.map(f => this.$set(f, '__generate', true));
						} else {
							r.Clocks = [];
						}
						this.loadInsertions();
						return r;
					})
					.finally(() => this.isLoading--);
			},
			async loadInsertions() {
				if (!this.showDateInfo) return;
				this.isLoading++;
				try {
					if (this.clocks.length)
						await Promise.all(this.clocks.map(f => this.loadInsertionByCreative(f?.Oid, f.Creative?.Oid)));
				} finally {
					this.isLoading--;
				}
			},
			async loadInsertionByCreative(clockId, creativeId) {
				if (!clockId || !creativeId) return;
				this.isLoading++;
				this.$Data.getInsertionsByCreative(creativeId).then(r => {
					this.$set(this.clockInsertions, clockId, _.orderBy((r?.Results || []).filter(f => getTypeFromInsertion(f) === 'audioFile'), ['StartTime']));
				}).finally(() => this.isLoading--);
			},
			generateEpisode() {
				const generateClocks = this.clocks.filter(f => f.__generate);
				if (!generateClocks.length) return;
				this.isBusy++;
				return Promise.all(generateClocks.map(async clock => {
					const insertions = this.clockInsertions[clock.Oid];
					const uploadData = await Promise.all(insertions.map(async ins => {
						if (ins.__file) {
							this.$set(ins, '__loading', true);
							const ext = _.last(ins.__file.name.split('.'));
							const audioBuffer = await this.$Data.getAudioBufferFromBlob(ins.__file);
							const azureInfo = await this.$azure.uploadBlobWithInfoResponse(`${this.$moment().format('YYYYMMDDHHmmss')}_${this.$Data.uuid()}.${ext}`, ins.__file, void 0, ({ percent }) => {
								this.$set(ins, '__uploadPercent', percent || 1);
							}).finally(() => this.$set(ins, '__loading', false));

							return {
								insertion: ins,
								azureInfo: {
									...azureInfo,
									Duration: parseInt(audioBuffer.duration * 1000)
								}
							}
						}

						return null;
					}));

					const response = await this.$Data.createEpisodeFromClock({
						ClockId: clock.Oid,
						NotifyOnCreativeGeneration: false,
						Name: clock.__episodeName,
						Description: clock.__episodeDescription,
						Subname: clock.__episodeSubname,
						AirDateTime: this.showDateInfo.NextDate,
						InsertionFiles: uploadData.filter(f => f).map(f => ({
							ObjectId: f.insertion.Oid,
							Oid: null,
							...f.azureInfo
						}))
					})

					if (__DEBUG__)
						console.debug('generateEpisode', { response });
				})).finally(() => {
					this.isBusy--;
					this.popupVisible = false;
					this.$eventsBus.$emit('new-episode-created');
				});
			}
		}
	};
</script>

<style lang='scss'>
	@import "main/themes/generated/variables.base.scss";

	.network-show--new-episode {
		.clock-header {
		}

		.insertions {
			margin-left: 2px;
		}
	}
</style>
